import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Tasks
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type TasksParameters = TasksTaskCreatedParameters | TasksTaskDeletedParameters | TasksCommentCreatedParameters | TasksFileCreatedParameters | TasksTimeCreatedParameters | TasksDashboardPromotionSelectedParameters;
export type TasksEvents = TasksTaskCreatedEvent | TasksTaskDeletedEvent | TasksCommentCreatedEvent | TasksFileCreatedEvent | TasksTimeCreatedEvent | TasksDashboardPromotionSelectedEvent;

export interface TasksTaskCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type TasksTaskCreatedParametersSpecific = Omit<
	TasksTaskCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const tasksTaskCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TasksTaskCreatedEventBuilder {
	constructor(private specificParameters: TasksTaskCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TasksTaskCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TasksTaskCreatedParametersSpecific,
            TasksTaskCreatedParameters,
			(params: TasksTaskCreatedParameters) => TasksTaskCreatedEvent
		>(this.specificParameters, tasksTaskCreatedParametersGlobal, globalParams, (params) => new TasksTaskCreatedEvent(params));
	}
}

/**
 * A user created a task.
 */
export class TasksTaskCreatedEvent extends CraftnoteEvent<TasksTaskCreatedParameters>{
  constructor(parameters: TasksTaskCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "add_task"
		},
		{
			name: "iterable",
			eventName: "tasks_task_created"
		},
	]);
  }
}
export interface TasksTaskDeletedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type TasksTaskDeletedParametersSpecific = Omit<
	TasksTaskDeletedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const tasksTaskDeletedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TasksTaskDeletedEventBuilder {
	constructor(private specificParameters: TasksTaskDeletedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TasksTaskDeletedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TasksTaskDeletedParametersSpecific,
            TasksTaskDeletedParameters,
			(params: TasksTaskDeletedParameters) => TasksTaskDeletedEvent
		>(this.specificParameters, tasksTaskDeletedParametersGlobal, globalParams, (params) => new TasksTaskDeletedEvent(params));
	}
}

/**
 * A user deleted a task.
 */
export class TasksTaskDeletedEvent extends CraftnoteEvent<TasksTaskDeletedParameters>{
  constructor(parameters: TasksTaskDeletedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "tasks_task_deleted"
		},
		{
			name: "iterable",
			eventName: "tasks_task_deleted"
		},
	]);
  }
}
export interface TasksCommentCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type TasksCommentCreatedParametersSpecific = Omit<
	TasksCommentCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const tasksCommentCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TasksCommentCreatedEventBuilder {
	constructor(private specificParameters: TasksCommentCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TasksCommentCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TasksCommentCreatedParametersSpecific,
            TasksCommentCreatedParameters,
			(params: TasksCommentCreatedParameters) => TasksCommentCreatedEvent
		>(this.specificParameters, tasksCommentCreatedParametersGlobal, globalParams, (params) => new TasksCommentCreatedEvent(params));
	}
}

/**
 * A user added a comment to a task
 */
export class TasksCommentCreatedEvent extends CraftnoteEvent<TasksCommentCreatedParameters>{
  constructor(parameters: TasksCommentCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "addCommentToTask"
		},
		{
			name: "iterable",
			eventName: "tasks_comment_created"
		},
	]);
  }
}
export interface TasksFileCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	mimeType: string; // MIME type of the uploaded file
	source: string; // source of the action, possible values are "camera", "storage", "scanner", "share", "pdf-editor", "photo-editor"
}

export type TasksFileCreatedParametersSpecific = Omit<
	TasksFileCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const tasksFileCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TasksFileCreatedEventBuilder {
	constructor(private specificParameters: TasksFileCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TasksFileCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TasksFileCreatedParametersSpecific,
            TasksFileCreatedParameters,
			(params: TasksFileCreatedParameters) => TasksFileCreatedEvent
		>(this.specificParameters, tasksFileCreatedParametersGlobal, globalParams, (params) => new TasksFileCreatedEvent(params));
	}
}

/**
 * A user added a file to a task
 */
export class TasksFileCreatedEvent extends CraftnoteEvent<TasksFileCreatedParameters>{
  constructor(parameters: TasksFileCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "addDataToTask"
		},
		{
			name: "iterable",
			eventName: "tasks_file_created"
		},
	]);
  }
}
export interface TasksTimeCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type TasksTimeCreatedParametersSpecific = Omit<
	TasksTimeCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const tasksTimeCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TasksTimeCreatedEventBuilder {
	constructor(private specificParameters: TasksTimeCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TasksTimeCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TasksTimeCreatedParametersSpecific,
            TasksTimeCreatedParameters,
			(params: TasksTimeCreatedParameters) => TasksTimeCreatedEvent
		>(this.specificParameters, tasksTimeCreatedParametersGlobal, globalParams, (params) => new TasksTimeCreatedEvent(params));
	}
}

/**
 * A user added a new time to a task.
 */
export class TasksTimeCreatedEvent extends CraftnoteEvent<TasksTimeCreatedParameters>{
  constructor(parameters: TasksTimeCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "add_timeentry_task"
		},
		{
			name: "iterable",
			eventName: "tasks_time_created"
		},
	]);
  }
}
export interface TasksDashboardPromotionSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type TasksDashboardPromotionSelectedParametersSpecific = Omit<
	TasksDashboardPromotionSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const tasksDashboardPromotionSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class TasksDashboardPromotionSelectedEventBuilder {
	constructor(private specificParameters: TasksDashboardPromotionSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<TasksDashboardPromotionSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			TasksDashboardPromotionSelectedParametersSpecific,
            TasksDashboardPromotionSelectedParameters,
			(params: TasksDashboardPromotionSelectedParameters) => TasksDashboardPromotionSelectedEvent
		>(this.specificParameters, tasksDashboardPromotionSelectedParametersGlobal, globalParams, (params) => new TasksDashboardPromotionSelectedEvent(params));
	}
}

/**
 * A user clicked on the CTA in the tasks dashboard promotion.
 */
export class TasksDashboardPromotionSelectedEvent extends CraftnoteEvent<TasksDashboardPromotionSelectedParameters>{
  constructor(parameters: TasksDashboardPromotionSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "tasksDashboard_promotionalBanner_upgrade"
		},
		{
			name: "iterable",
			eventName: "tasks_dashboard_promotion_selected"
		},
	]);
  }
}
